import styled from "styled-components";
import { COLORS, FONT_SIZE, FONT_WEIGHT } from "../../../constants/Styles";

export const Pill = styled.div`
  border-radius: 1rem;
  background: ${COLORS.altPrimary};
  padding: 0.25rem 0.75rem 0.25rem 0.5rem;
  display: flex;
  align-items: center;
  font-size: ${FONT_SIZE.size14};
  font-weight: ${FONT_WEIGHT.weight500};
  gap: 2px;
  color: ${COLORS.secondary};
  max-width: 100%;
  width: fit-content;
`;

export const Email = styled.div`
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
`;
